/**
 * @generated SignedSource<<2ac7a48be50960ca289fe2f2258b7306>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerPaymentViewRefreshQuery$variables = {
  id: string;
};
export type CustomerPaymentViewRefreshQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CustomerPaymentView_customerAccount">;
  } | null | undefined;
};
export type CustomerPaymentViewRefreshQuery = {
  response: CustomerPaymentViewRefreshQuery$data;
  variables: CustomerPaymentViewRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerPaymentViewRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerPaymentView_customerAccount"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerPaymentViewRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentMethod",
                "kind": "LinkedField",
                "name": "defaultPaymentMethod",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentMethod",
                "kind": "LinkedField",
                "name": "paymentMethods",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentMethodType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardBrand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastFourDigits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expirationDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentTerms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mandateReference",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "CustomerAccount",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3afc5fc1ca7cb0040f3fdef951998249",
    "id": null,
    "metadata": {},
    "name": "CustomerPaymentViewRefreshQuery",
    "operationKind": "query",
    "text": "query CustomerPaymentViewRefreshQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CustomerPaymentView_customerAccount\n    id\n  }\n}\n\nfragment CustomerPaymentView_customerAccount on CustomerAccount {\n  id\n  customerName\n  defaultPaymentMethod {\n    id\n  }\n  paymentMethods {\n    id\n  }\n  ...DetailedPaymentMethodList_customerAccount\n}\n\nfragment DeletePaymentMethodDialog_paymentMethod on PaymentMethod {\n  id\n  paymentMethodType\n  cardBrand\n  lastFourDigits\n}\n\nfragment DetailedPaymentMethodList_customerAccount on CustomerAccount {\n  id\n  defaultPaymentMethod {\n    id\n  }\n  paymentMethods {\n    id\n    paymentMethodType\n    cardBrand\n    lastFourDigits\n    expirationDate\n    paymentTerms\n    mandateReference\n    ...SetDefaultPaymentMethodDialog_paymentMethod\n    ...DeletePaymentMethodDialog_paymentMethod\n  }\n  ...SetDefaultPaymentMethodDialog_customerAccount\n}\n\nfragment SetDefaultPaymentMethodDialog_customerAccount on CustomerAccount {\n  id\n  customerName\n}\n\nfragment SetDefaultPaymentMethodDialog_paymentMethod on PaymentMethod {\n  id\n  paymentMethodType\n  cardBrand\n  lastFourDigits\n}\n"
  }
};
})();

(node as any).hash = "f140a8ff2dbb19390caa6f770b7eadc0";

export default node;
